/*
 *		Copyright (c) 2011-2015 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

/* Filters */
angular.module('access.Resource')
    .filter('apiAddress', ['ENV', function (ENV) {
        return function (address) {
            // If address is public - do nothing
            if(address.indexOf(ENV.relativeUrlRoot + '/public') === 0) {
                return address;
            }

            return ENV['apiAddress'] + address;
        };
    }]);
